import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  max-width: 100vw;
  min-height: 1000px;

  background: ${({ theme }) => theme.clientCases.background};

  padding: 50px 0;

  transition: background 0.15s linear;

  display: flex;
  justify-content: center;

  margin-top: 116px;

  @media (max-width: 700px) {
    min-height: 900px;
  }
`;

export const Section = styled.section`
  width: 100%;
  max-width: 1050px;

  display: flex;
  flex-direction: column;
  align-items: center;

  h2 {
    font-size: 40px;
    line-height: 48px;
    margin-top: 10px;
    text-align: center;
  }

  @media (max-width: 1088px) {
    padding: 0 30px;
  }

  @media (max-width: 500px) {
    padding: 0 20px;
  }
`;

export const Cards = styled.div`
  width: 100%;
  height: 100%;

  position: relative;
  overflow: hidden;

  display: flex;
  justify-content: center;

  margin-top: 40px;

  @media (max-width: 700px) {
    max-height: 650px;
  }
`;

export const Card = styled.div`
  position: absolute;

  transition: 0.2s ease-in-out;

  -webkit-user-select: none; /* Safari */
  -ms-user-select: none; /* IE 10 and IE 11 */
  user-select: none; /* Standard syntax */

  &.keep-left {
    transform: translateX(-95%) scale(0.8);
  }
  &.keep-right {
    transform: translateX(95%) scale(0.8);
  }

  &.centro {
    transform: translateX(0) scale(1);
    opacity: 1;
    z-index: 2;
  }
  &.esquerda {
    transform: translateX(-95%) scale(0.8);
    z-index: 0;
    opacity: 0.5;
    filter: blur(5px);
  }
  &.direita {
    transform: translateX(95%) scale(0.8);
    z-index: 0;
    opacity: 0.5;
    filter: blur(5px);
  }

  &.hidden {
    opacity: 0;
    z-index: 0;
  }

  height: 100% !important;

  @media (max-width: 700px) {
    * {
      height: 100% !important;
    }
  }

  @media (max-width: 500px) {
    &.direita {
      transform: translateX(90%) scale(0.8);
    }
    &.esquerda {
      transform: translateX(-90%) scale(0.8);
    }
  }
`;

export const TranslateButton = styled.button`
  position: absolute;
  top: calc(50% - 28px);

  cursor: pointer;

  display: flex;
  justify-content: center;
  align-items: center;

  height: 56px;
  width: 56px;

  background: black;
  color: white;

  border-radius: 50%;

  border: none;
  outline: none;

  &.next {
    left: 81%;
    z-index: 3;
  }

  &.previous {
    right: 81%;
    z-index: 3;
  }

  @media (max-width: 375px) {
    height: 40px;
    width: 40px;
  }
`;
